export default __webpack_public_path__ + "static/media/PullOutDesignResistance.91902f05.svg";